import { BaseEntity } from '@macs-frontend/features/shared';

export enum TaskRoleStatuses {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface TaskRole extends BaseEntity {
  name: string;
  status: TaskRoleStatuses;
}
